var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as ui_ from './systems/ui';
import * as line_ from './brushes/line';
import * as rainbox_ from './brushes/rainbow';
import * as single_sphere_ from './brushes/single-sphere';
import * as spheres_ from './brushes/spheres';
import * as stamp_ from './brushes/stamp';
import * as brush_tip_ from './components/brush-tip';
import * as brush_ from './components/brush';
import * as json_model from './components/json-model';
import * as logo_model from './components/logo-model';
import * as blink_controls from './components/blink-controls';
import * as paint_controls from './components/paint-controls';
import * as ui_raycaster from './components/ui-raycaster';
import * as ui from './components/ui';
import * as cubes from './brushes/cubes';
import * as custom_event_set from './components/event-sets';
import * as paint_canvas_ray_listener from './components/paint-canvas-ray-listener';
import * as frame_interactions from './components/frame_interactions';
import * as infinit_list from './components/infinite-list';
import atlas from './atlas';
import gui from '../gui/index';
var registered = {};
export default function painter() {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (registered['painter']) {
                        return [2 /*return*/];
                    }
                    if (!registered['gui']) {
                        registered['gui'] = true;
                        gui();
                    }
                    if (!registered['infinit_list']) {
                        registered['infinit_list'] = true;
                        infinit_list.default();
                    }
                    // if (!registered['interaction_panel']) {
                    //     registered['interaction_panel'] = true;
                    //     interaction_panel.default();
                    // }
                    if (!registered['frame_interactions']) {
                        registered['frame_interactions'] = true;
                        frame_interactions.default();
                    }
                    if (!registered['ui_']) {
                        registered['ui_'] = true;
                        ui_.default();
                    }
                    if (!registered['cubes']) {
                        registered['cubes'] = true;
                        cubes.default();
                    }
                    if (!registered['custom_event_set']) {
                        registered['custom_event_set'] = true;
                        custom_event_set.default();
                    }
                    if (!registered['paint_canvas_ray_listener']) {
                        registered['paint_canvas_ray_listener'] = true;
                        paint_canvas_ray_listener.default();
                    }
                    if (!registered['spheres_']) {
                        spheres_.default();
                        registered['spheres_'] = true;
                    }
                    if (!registered['blink_controls']) {
                        blink_controls.default();
                        registered['blink_controls'] = true;
                    }
                    if (!registered['rainbox_']) {
                        rainbox_.default();
                        registered['rainbox_'] = true;
                    }
                    if (!registered['single_sphere_']) {
                        single_sphere_.default();
                        registered['single_sphere_'] = true;
                    }
                    if (!registered['brush_tip_']) {
                        brush_tip_.default();
                        registered['brush_tip_'] = true;
                    }
                    if (!registered['brush_']) {
                        brush_.default();
                        registered['brush_'] = true;
                    }
                    if (!registered['paint_controls']) {
                        paint_controls.default();
                        registered['paint_controls'] = true;
                    }
                    if (!registered['logo_model']) {
                        logo_model.default();
                        registered['logo_model'] = true;
                    }
                    if (!registered['json_model']) {
                        json_model.default();
                        registered['json_model'] = true;
                    }
                    if (!registered['ui']) {
                        ui.default();
                        registered['ui'] = true;
                    }
                    if (!registered['ui_raycaster']) {
                        ui_raycaster.default();
                        registered['ui_raycaster'] = true;
                    }
                    if (!!registered['atlas']) return [3 /*break*/, 2];
                    registered['atlas'] = true;
                    return [4 /*yield*/, atlas().then(function () {
                            if (!registered['stamp_']) {
                                stamp_.default();
                                registered['stamp_'] = true;
                            }
                            if (!registered['line_']) {
                                line_.default();
                                registered['line_'] = true;
                            }
                        })];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    });
}
